import { render } from "./PrimaryTemplate.vue?vue&type=template&id=63ed97c6&scoped=true"
import script from "./PrimaryTemplate.vue?vue&type=script&lang=js"
export * from "./PrimaryTemplate.vue?vue&type=script&lang=js"

import "./PrimaryTemplate.vue?vue&type=style&index=0&id=63ed97c6&lang=scss"
import "./PrimaryTemplate.vue?vue&type=style&index=1&id=63ed97c6&lang=scss&scoped=true"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ed97c6"]])

export default __exports__